import '@updater-components/icon';
import template from './code.html';
import { actions, selectors } from '../../../../state';
import './code.global.css';

class VerifyPhoneCodeController {
  constructor(updStore) {
    'ngInject';
    Object.assign(this, { updStore });
  }

  $onInit() {
    this.disconnect = this.updStore.connect(mapStateToThis)(this);
  }

  $onDestroy() {
    this.disconnect();
  }

  resend() {
    const { dispatch } = this.updStore;

    const success = response => {
      dispatch(
        actions.message.success(
          `Success! We're sending a new code to the phone number provided.`
        )
      );
      dispatch(actions.analytics.track('Resent Phone Verify Code'));
    };

    const error = response => {
      dispatch(
        actions.message.success(
          `Sorry. Something went wrong. Please try again later.`
        )
      );
      dispatch(
        actions.analytics.track('Tried Resending Phone Verify Code', {
          Errors: response.payload.errors,
        })
      );
    };

    dispatch(
      actions.phoneVerification.requestPin({
        move_id: this.moveId,
        phone_number: this.phoneNumber,
        delivery_method: this.deliveryMethod,
      })
    ).then(success, error);
  }

  submit(pin) {
    const { dispatch } = this.updStore;

    const success = response => {
      dispatch(actions.router.stateGo(this.origin, { verified: true }));
      dispatch(actions.analytics.track('Verified By Phone'));
    };

    const error = response => {
      dispatch(
        actions.message.error(
          `Sorry. The codes don't match - please try again.`
        )
      );
      dispatch(
        actions.analytics.track('Tried To Verify By Phone', {
          Errors: response.payload.errors,
        })
      );
    };

    dispatch(
      actions.move.verification(this.moveId, {
        kind: 'phone',
        phone_number: this.phoneNumber,
        pin,
      })
    ).then(success, error);
  }
}

export const VerifyPhoneCodeComponent = {
  template,
  controller: VerifyPhoneCodeController,
  bindings: {
    origin: '<',
  },
};

function mapStateToThis(state) {
  return {
    moveId: selectors.current.move(state).id(state),
    resending: selectors.pending.match(
      actions.phoneVerification.isRequestPin,
      state
    ),
    submitting: selectors.pending.match(actions.move.isCreate, state),
    phoneNumber: selectors.router.currentParamsProp('phone_number', state),
    deliveryMethod: selectors.router.currentParamsProp(
      'delivery_method',
      state
    ),
  };
}
